module.exports = __webpack_public_path__ + "static/media/teygja_abs_a.9e4e0f13.png";